module.exports = __webpack_public_path__ + "1_0_64/img/app-store-badge.2928664f.svg";